<template>
  <div>
    <span id="log" style="color: red;display:none"></span>    
  </div>
</template>

<script>
//import firebase from "firebase";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import "signalr";
import Global from "@/components/Global";
import { SignalrConnectionHandler } from "@/handler/SignalrConnectionHandler.js";

function notifyMe(notificationData) {
  var text = $("#log").text();
  if (text != "") {
    return false;
  }
  
  sendNotify({
    title: notificationData.data.title,
    body: notificationData.data.body,
    tag: notificationData.data.tag,
    icon: notificationData.data.icon,
    link: notificationData.data.link
  });
}

function sendNotify(msg) {
  var notify = new Notification(msg.title, {
    icon: msg.icon,
    body: msg.body,
    tag: msg.tag
  });
  setTimeout(function() {
    notify.close();
  }, 5000);
  notify.onshow = function() {};

  if (msg.link) {
    notify.onclick = function(e) {
      e.preventDefault();
      window.open(msg.link);
    };
  }
}

export default {
  data() {
    return {
      staff: this.GetLoginStaff(),
      conn: null
    };
  },
  // 元件銷毀時一定要停掉連線。SignalrConnectionHandler 會無限退避重連，
  // 沒停的話會留下永遠重連的殭屍連線。
  beforeDestroy() {
    if (this.conn && typeof this.conn.stop === "function") {
      this.conn.stop();
    }
  },
  mounted() {
    if (!("Notification" in window)) {
      return false;
    }
    if (Notification.permission === "denied") {
      return false;
    }
  },
  created() {
    if (!("Notification" in window)) {
      return false;
    }

    if (Notification.permission === "denied") {
      return false;
    }

    this.registeFCM(); //servicework
    this.iniSignalr(); //signalr notify
  },
  methods: {
    iniSignalr: function() {
      var staffid = this.staff.staffid;
      // 存在元件上，beforeDestroy 才停得掉（否則會留下永遠重連的殭屍連線）
      this.conn = SignalrConnectionHandler.Create({
        url: this.$conf.MessageAPI + "/signalr",
        hub: "pushHub",
        // 每次重連成功後都要重新註冊，否則推播不會再進來
        onConnected: function(proxy) {
          proxy.invoke("IniWebPush", staffid);
        }
      });
      var proxy = this.conn.proxy;
      this.conn.start();

      proxy.on("notifyMe", data => {
        notifyMe(data);
      });
    },
    registeFCM() {
      if (!window.Notification) {
        return;
      }

      this.initFirebase();

      // 舊的設定
      // const FCMconfig = {
      //   apiKey: "AIzaSyAroqyCLCwqZJMhluwzjCZyLKYIYwkBV1s",
      //   messagingSenderId: "497456436043",      
      // };
      
    },    
    sendTokenToServer(token) {
      $("#log").append(token + "<br><br>");
      $.ajax({
        url: this.$conf.MessageAPI + "/WebPush/ReceiveUserToken",
        type: "POST",
        cache: false,
        data: { userToken: token, staffId: this.staff.staffid },
        dataType: "json",
        async: false
      })
        .done(function(res) {
          //resp = res;
          //console.log(res);
        })
        .fail(function(error) {
          //console.log(error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Main/WebPushForPC.vue